// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"371":"1c60ffcd58cfcd9d","396":"144b71ec0af5e453","936":"4ca1ba076449843b"}[chunkId] + ".js";
};